import { render, staticRenderFns } from "./resources/schedule.pug?vue&type=template&id=4c328c53&scoped=true&lang=pug&"
import script from "./WeekSchedule.vue?vue&type=script&lang=js&"
export * from "./WeekSchedule.vue?vue&type=script&lang=js&"
import style0 from "./WeekSchedule.vue?vue&type=style&index=0&id=4c328c53&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c328c53",
  null
  
)

export default component.exports